import React, { useState, useEffect, useRef, useMemo } from "react";
// import * as faceapi from "@vladmandic/face-api";
//import {throttle,debounce} from 'lodash'
import Candidatecard from "../candidateCard/candidateCard";
import Button from "react-bootstrap/Button";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ReactComponent as FaceCaptureIcon } from "../../images/faceCapture.svg";
import { useUserMedia } from "../../custom-hooks/useUserMedia";
import {
  // loadApis,
  // drawBox,
  // getDisplaySize,
  videoSnaphotToBlob,
  // isFaceDetectionModelLoaded,
  // tinydetectorOptions,
} from "../../utils/faceapi_utils";
import { useSelector } from "react-redux";
import { ReactComponent as SuccessCheck } from "../../images/successCheck.svg";
import { ReactComponent as FailureSignal } from "../../images/failureSignal.svg";
import { ReactComponent as FaceBoxIcon } from "../../images/faceBoxIcon.svg";
import { addRoute } from "../../redux/features/candidate/candidateAuthSlice";

import "./authentication.scss";
import axios from "axios";
import { toast } from "react-toastify";
import { drawResults, getDetector } from "../../utils/midia-pipe-detect";
import { isMobile } from "@tensorflow/tfjs-core/dist/device_util";
import { VIDEO_SIZE } from "../../utils/utils";

const Authentication = () => {
  const userData = useSelector((state) => state?.auth.userData);
  let history = useHistory();
  const dispatch = useDispatch();
  const videoEl = useRef();
  const canvasEl = useRef();
  const timeInterval = useRef();
  const displaySize = useRef();
  const [imageShot, setImageShot] = useState(false);
  const [context, setContext] = useState();
  const detector = useRef();
  const [loaded, setLoaded] = useState(false);
  const [status, setStatus] = useState({
    loading: true,
    success: false,
    error: false,
  });
  const requestedMedia = useMemo(
    () => ({
      audio: false,
      video: {
        facingMode: "user",
        width: isMobile()
          ? VIDEO_SIZE["360 X 270"].width
          : VIDEO_SIZE["480 X 360"].width,
        height: isMobile()
          ? VIDEO_SIZE["360 X 270"].height
          : VIDEO_SIZE["480 X 360"].height,

        // resizeMode: "crop-and-scale"
      },
    }),
    []
  );
  const mediaStream = useUserMedia(requestedMedia);

  /*
  button handlers
  **/
  const handleProceed = () => {
    const path = "/environment";
    if (true) {
      dispatch(addRoute(path));
      history.push(path);
    }
  };
  const handleTryAgain = () => {
    setImageShot(false);
    setStatus({ loading: false, success: false, error: false });
    videoEl.current.play();
  };

  /*
  useEffects hooks for initiators and preventive rerenders
  **/
  useEffect(() => {
    videoEl.current.srcObject = mediaStream;
    return () => {
      mediaStream?.getTracks().forEach((track) => track.stop());
    };
  }, [mediaStream]);

  // const loaded = isFaceDetectionModelLoaded(faceapi);
  useEffect(() => {
    if (loaded) {
      setStatus((values) => ({ ...values, loading: false }));
      console.log("face model is loaded");
    }
    console.log("this function loaded", loaded);
    if (loaded && !imageShot) {
      setStatus({ loading: false, success: false, error: false });
    }
  }, [imageShot, loaded]);

  const loadDetector = async () => {
    try {
      const myDetector = await getDetector({ maxFaces: 1 });
      console.log({ myDetector });
      if (myDetector) {
        setLoaded(true);
      }
      console.log({ myDetector });
      detector.current = myDetector;
    } catch (error) {
      console.error({ error });
    }
  };

  useEffect(() => {
    setContext(canvasEl.current.getContext("2d"));
    // console.log("initate faceapi");
    // loadApis(faceapi)
    loadDetector()
      .then(() => setStatus((values) => ({ ...values, loading: false })))
      .catch((e) => {
        //do something
        loadDetector();
        console.log(e);
      });
    return () => {
      clearInterval(timeInterval.current);
    };
  }, []);

  function handleCanPlay() {
    // displaySize.current = {
    //   width: videoEl.current.videoWidth,
    //   height: videoEl.current.videoHeight,
    // };
    // canvasEl.current.width = videoEl.current.videoWidth;
    // canvasEl.current.height = videoEl.current.videoHeight;
    // const myContext = canvasEl.current.getContext("2d");
    // console.log(displaySize);
    // myContext.translate(videoEl.current.videoWidth, 0);
    // myContext.scale(-1, 1);
    // setContext(myContext);
    videoEl.current.play();
    clearInterval(timeInterval.current);
    timeInterval.current = setInterval(() => {
      handleProgress();
    }, 500);
    console.log("canPlay is pressed");
  }

  const onLoadVideo = () => {
    console.info("this is the log boss");
    displaySize.current = {
      width: videoEl.current.videoWidth,
      height: videoEl.current.videoHeight,
    };
    canvasEl.current.width = videoEl.current.videoWidth;
    canvasEl.current.height = videoEl.current.videoHeight;
    const myContext = canvasEl.current.getContext("2d");
    console.log(displaySize);
    myContext.translate(videoEl.current.videoWidth, 0);
    myContext.scale(-1, 1);
    setContext(myContext);
  };

  const handleProgress = async () => {
    // console.log("the type is", event.type);
    // console.log("on play worked");
    context.clearRect(0, 0, canvasEl.current.width, canvasEl.current.height);
    if (!detector.current?.faceDetectorSolution) {
      console.log("the detector is still loading", { detector });
      return;
    }
    console.log("this is imageshot", imageShot);
    if (imageShot) {
      return;
    }
    let results = await detector.current?.estimateFaces(videoEl.current, {
      flipHorizontal: false,
    });
    let result = results[0];
    console.log("this is the result", result);
    if (result) {
      if (imageShot && loaded) {
        console.log("pause is pressed");
        return;
      }

      //drawing box with result
      // drawBox(result.box, context);
      console.info({ context });
      drawResults(context, [result], true, false);
      window.onkeydown = async function (e) {
        // make <canvas> of the same size

        if (e.keyCode === 13 && !imageShot) {
          try {
            videoEl.current.pause();
            //throw new Error("an err occured")
            let imageBlob = await videoSnaphotToBlob(
              videoEl.current,
              displaySize.current
            );
            console.log({ imageBlob });
            if (!userData.imageUrl) {
              toast.info("user has no valid image");
              return;
            }
            //send imageBlob to backend via http api
            imageBlob.lastModifiedDate = new Date();
            imageBlob.name = "facial-authentication.png";
            console.log(imageBlob);
            let photoData = new FormData();
            photoData.append("photo", imageBlob);
            photoData.append("purpose", "authentication");
            photoData.append("imageUrl", userData.imageUrl);

            const res = await axios.post("/facial", photoData);

            if (res) {
              clearInterval(timeInterval.current);
              setStatus({ loading: false, error: false, success: true });
            }
            setImageShot(true);
          } catch (err) {
            if (err.response) {
              toast.error(err.response.data.message);
            } else {
              toast.error(err.message);
            }
            setStatus({ loading: false, success: false, error: true });
          }
        }
      };
    } else {
      window.onkeydown = null;
      context.clearRect(0, 0, canvasEl.current.width, canvasEl.current.height);
    }
  };

  if (imageShot) videoEl.current.pause();
  window.onkeydown = null;

  return (
    <div className="authentication-container bg-white">
      <div className="title border-bottom p-3 ">
        <h6 className="font-weight-bold text-primary mb-0">Authentication</h6>
      </div>
      <div className="p-4 row border-bottom">
        <div className="col-lg-4 border-end">
          <Candidatecard
            userData={userData}
            message={"make sure your face aligns at the center of the box"}
          />
        </div>
        <div className="col-lg-8 ps-4">
          <div className="detail-title d-flex justify-content-start align-items-center border-bottom bg-primary mb-3">
            <FaceCaptureIcon />
            <h6 className="font-weight-bold text-white ms-2 mb-0">
              Face Capture
            </h6>
          </div>
          <div className="video-cam-container position-relative w-100 d-flex justify-content-center align-items-center">
            <div className="position-relative">
              <video
                ref={videoEl}
                onCanPlay={handleCanPlay}
                // onProgress={handleProgress}
                autoPlay
                muted
                playsInline
                style={{
                  width: "auto",
                  height: "auto",
                  transform: "scaleX(-1)",
                  // visibility:"hidden",
                }}
                onLoadedMetadata={onLoadVideo}
                height={360}
                width={480}
              ></video>
              <canvas
                className="position-absolute top-0 start-0 zindex-dropdown"
                ref={canvasEl}
                // style={{
                //   zIndex: 20,
                // }}
              ></canvas>
              <FaceBoxIcon
                className="position-absolute top-50 start-50 translate-middle"
                // style={{ zIndex: 30 }}
              />
            </div>

            {status.success && (
              <div className="success-box p-4 position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center">
                <div className="d-flex flex flex-column align-items-center justify-content-between h-100 w-100">
                  <SuccessCheck />
                  <p className="text-primary m-0">Authentication successful!</p>
                  <Button variant="success" onClick={handleProceed}>
                    Proceed
                  </Button>
                </div>
              </div>
            )}

            {status.error && (
              <div className="failed-box p-4 position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center">
                <div className="d-flex flex flex-column align-items-center justify-content-between h-100 w-100">
                  <FailureSignal />
                  <p className="text-primary m-0">Error! Please try again</p>
                  <Button variant="outline-info" onClick={handleTryAgain}>
                    Try Again
                  </Button>
                </div>
              </div>
            )}

            {status.loading && (
              <div className="loading-box p-4 position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center">
                <div className="d-flex flex flex-column align-items-center justify-content-center h-100 w-100">
                  <p className="text-white m-0 fst-italic">Pease Wait ...</p>
                </div>
              </div>
            )}

            <p className="bg-primary text-white position-absolute m-0 p-1 bottom-0 end-0">
              Press enter to snap when the green box appears
            </p>
          </div>
        </div>
      </div>

      <div className="py-4"></div>
    </div>
  );
};

export default Authentication;
